var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-8 login-tabs-container"},[_c('h4',{staticClass:"mb-8"},[_vm._v(_vm._s(_vm.$t('message.register.newClientHeader')))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('message.register.registrationDone', {num: _vm.number}))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }